import moment from 'moment';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const EXTENDED_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const REVERSE_DASH_DATE_FORMAT = 'YYYY-MM-DD';

export function dateToString(date) {
  return date ? moment(date).format(DATE_FORMAT) : '';
}

export function dateTimeToString(date) {
  return date ? moment(date).format(DATE_TIME_FORMAT) : '';
}

export function toExtendedDateFormat(date) {
  return date ? moment(date, DATE_TIME_FORMAT).format(EXTENDED_DATE_TIME_FORMAT) : '';
}

export function reverseDateToString(date) {
  return date ? moment(date).format(REVERSE_DASH_DATE_FORMAT) : '';
}

export function isDateBefore(firstDate, secondDate) {
  const newFirstDate = new Date(firstDate);
  const newSecondDate = new Date(secondDate);

  return moment(newFirstDate).isBefore(newSecondDate);
}

export function isTodayOrFutureDate(firstDate, secondDate) {
  const newFirstDate = new Date(firstDate);
  const newSecondDate = new Date(secondDate);
  return moment(newFirstDate)
    .startOf('day')
    .isSameOrBefore(moment(newSecondDate).startOf('day'));
}

export function isBeforeOrPresentDate(value) {
  const date = moment(value);
  if (!date.isValid()) return false;

  const now = moment();
  return now.isSameOrBefore(date);
}

export function getTodayDate(format = REVERSE_DASH_DATE_FORMAT) {
  return moment().startOf('day').format(format);
}

export function getDateDaysAgo(days, format = REVERSE_DASH_DATE_FORMAT) {
  return moment().subtract(days, 'day').startOf('day').format(format);
}
